var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.steps),function(step,stepKey,stepIndex){return _c('router-link',{key:step.id,class:_vm.cssClass(stepKey),style:(_vm.cssStyle(stepIndex)),attrs:{"to":_vm.path(step.id)}},[_c('span',[_vm._v(_vm._s(step.label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }